import { motion } from 'framer-motion';
import { Lock } from '@phosphor-icons/react';

import pt from '../../../locales/pt';
import { cn } from '../../../utils/cn';

/**
 * Passo final — revelação de libertação.
 */
export function DebtDoneStep({ freeDate, summary = [] }) {
  const copy = pt.liabilities.repaymentWizard.done;

  return (
    <div className="flex flex-col items-center pt-3.5 text-center">
      <motion.div
        initial={{ scale: 0.6, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: 'spring', stiffness: 320, damping: 18 }}
        className="flex h-[78px] w-[78px] items-center justify-center rounded-full bg-sage-600 shadow-[0_14px_30px_-12px_rgba(95,126,84,0.7)]"
      >
        <Lock className="h-10 w-10 text-white" weight="regular" aria-hidden />
      </motion.div>

      <div className="mt-[18px] text-[11px] font-bold uppercase tracking-[0.1em] text-sage-600 dark:text-sage-400">
        {copy.eyebrow}
      </div>
      <h1 className="mt-2 font-display text-[26px] font-semibold leading-tight tracking-tight text-foreground">
        {copy.title.replace('{date}', freeDate)}
      </h1>
      <p className="mt-2 max-w-[290px] text-sm leading-relaxed text-muted-foreground">
        {copy.subtitle}
      </p>

      {summary.length > 0 ? (
        <div className="mt-5 w-full overflow-hidden rounded-2xl border border-border">
          {summary.map((row, index) => (
            <div
              key={row.label || index}
              className={cn(
                'flex items-center justify-between px-[15px] py-3.5',
                index < summary.length - 1 && 'border-b border-border/80',
              )}
            >
              <span className="text-[13px] text-muted-foreground">{row.label}</span>
              <span
                className={cn(
                  'text-[13.5px] font-semibold tabular-nums text-foreground',
                  row.accent && 'text-sage-600 dark:text-sage-400',
                )}
              >
                {row.value}
              </span>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}

export default DebtDoneStep;
